import _ from 'lodash';
import React, { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDefaultDashboardSelector } from '../../../../../../../redux/reducers/reducerSlices/DefaultDashboardReducer';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { createChartsProps, donutType, numberWithCommas } from '../../../../../../Assests/DashboardUtility';
import StatusOverviewDash from '../StatusOverviewDash/StatusOverviewDash';
import AppointmentCompliance from './Children/AppointmentCompliance/AppointmentCompliance';
import DetentionStatus from './Children/DetentionStatus/DetentionStatus';
import UnloadingHours from './Children/UnloadingHours/UnloadingHours';
import TaskItemsDue from '../TaskItemsDueComponent/TaskItemsDue';
import './DefaultDashboardWrapper.css';
import { getSelectedDateSelector } from '../../../../../../../redux/reducers/reducerSlices/DateSelectorReducer';
import { getFormattedDate, YYYY_MM_DD_FORMAT, convertGmtToDateRange, getCurrentDate } from '../../../../../../../Utils/DateUtils';
import { getSelectedDockFilterListSelector } from '../../../../../../../redux/reducers/reducerSlices/FiltersReducerSlice';
import { getDockListSelector } from '../../../../../../../redux/reducers/reducerSlices/DockListReducer';
import { createDocksIdArr } from '../../../POFilters/FilterUtilities';
import { unloadingHoursDonut, unloadingHoursLineTruck, unloadingHoursLinePallet, detentionLineData, detentionDonutdata, appointmentComplianceData } from '../../../../../../Assests/GraphUtilities';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { usePrevious } from '../../../../../Common/CustomHooks/usePrevious';
import moment from 'moment';
import { closeUpdatesSocketConnection, initializeUpdatesSocketConnection } from '../../../../../../../Utils/updateSocket';

const DefaultDashboardWrapper = (props) => {
    const { themeSelected, dockIdArr } = props;
    const [unloadingHoursData, setUnloadingHoursData] = useState({ ...props, unloadingHoursDonut, unloadingHoursLineTruck, unloadingHoursLinePallet })
    const [detentionStatusData, setDetentionStatusData] = useState({ ...props, detentionDonutdata, detentionLineData })
    const [appointmentComplianceState, setAppointmentComplianceState] = useState({ ...props, appointmentComplianceData })
    const defaultDashboard = useSelector(getDefaultDashboardSelector);
    const { unloadingHours, detentionStatus, appointmentCompliance, autoFetch, dateRangeObj, isWorkDay } = defaultDashboard;
    const getSelectedDateSelectorObj = useSelector(getSelectedDateSelector);
    const dockIdArrRef = useRef([]);
    const { selectedDate } = getSelectedDateSelectorObj;
    const dispatch = useDispatch();
    const userPermission = useSelector(getUserSelector);
    const { selectedWarehouse, isOnline } = userPermission;
    const previousDateRangeObj = usePrevious(dateRangeObj);
    const socketRef = useRef(null);
    const reconnectionTimeoutRef = useRef(null);
    const reconnectionAttemptsRef = useRef(0);
    const heartBeatIntervalRef = useRef(null);
    const isOnlineRef = useRef(isOnline);
    // useEffect(() => {
    //     if (selectedDockFiltersList.length) {
    //         const updatedDockIdArr = createDocksIdArr(selectedDockFiltersList, dockList, false);
    //         setDockIdArr(updatedDockIdArr);
    //         dockIdArrRef.current = updatedDockIdArr;
    //         // const updatedDockIdArrDrillDown = createDocksIdArr(selectedDockFiltersList, dockList, true);
    //         dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: updatedDockIdArr })

    //     } else {
    //         createDocksIdArr([])
    //         dockIdArrRef.current = [];
    //         dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: [] })
    //     }
    // }, [selectedDockFiltersList])


    useEffect(() => {
        //Implemented realtime refresh      
        // autoFetchAPI()       
        // dispatch({ type: sagaActions.RESET_FILTERS, payload: '' });
        return () => {
            // dispatch({ type: sagaActions.CLEAR_FILTERS });
            // dispatch({ type: sagaActions.RESET_TRUCK_DATA })
            // dispatch({ type: sagaActions.RESET_ANALYTICS })
            // dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: [] })
            // setDockIdArr([]);  
            // dockIdArrRef.current = [];
        }
    }, [])

    useEffect(() => {
        isOnlineRef.current = isOnline;
    }, [isOnline]);

    useEffect(() => {
        if (isOnline && selectedWarehouse.ID) {
            console.log('isOnline', isOnline)
            connectSocket();
        }

        return () => {
            closeSocketConnection(true); // Clean close on unmount
        };
    }, [isOnline, selectedWarehouse.ID]);
    /**
     * Method is used to handle truck update and fetch latest truck data
     */
    const onUpdateSocketReceived = (message) => {
        let parsedMessage = JSON.parse(message)
        if (typeof parsedMessage === 'string') {
            parsedMessage = JSON.parse(parsedMessage)
        }
        if (!_.isEmpty(parsedMessage)) {
            const { type } = parsedMessage;
            switch (type) {
                case 'CHECK_IN_TIME':
                    fetchAnalyticsData();
                    break;
                case 'LUMP_START_TIME':
                    fetch_DASHBOARD_STATUS_TRUCK_LIST();
                    fetch_GET_TASK_ITEMS_DUE_LIST()
                    break;
                case 'LUMP_END_TIME':
                    fetch_DASHBOARD_STATUS_TRUCK_LIST();
                    fetch_GET_TASK_ITEMS_DUE_LIST()
                    break;
                case 'IN_DOOR_TIME':
                    fetch_DASHBOARD_STATUS_TRUCK_LIST();
                    fetch_GET_TASK_ITEMS_DUE_LIST()
                    break;
                // case 'CHECK_OUT_TIME':
                //     fetch_DASHBOARD_STATUS_TRUCK_LIST();
                //     fetch_GET_TASK_ITEMS_DUE_LIST();
                //     break;
                case 'BILLS_IN_TIME':
                    fetch_DASHBOARD_STATUS_TRUCK_LIST();
                    fetch_GET_TASK_ITEMS_DUE_LIST();
                    break;
                case 'BILLS_OUT_TIME':
                    fetchAnalyticsData();
                    break;
                case 'SCHEDULED_TIME':
                    fetchAnalyticsData();
                    break;
                default:
                    fetchAnalyticsData()
                    break;
            }
        }

        // fetchAnalyticsData()
    }

    const connectSocket = () => {
        if (!isOnlineRef.current) {
            console.log("Application is offline. Skipping connection attempt.");
            return;
        }

        if (socketRef.current) {
            socketRef.current.close();
        }
        socketRef.current = initializeUpdatesSocketConnection(
            selectedWarehouse.ID,
            AppConstant.commonStrings.truckUpdateSocketUrl,
            onUpdateSocketReceived,
            onUpdateSocketError,
            onUpdateSocketClose,
            onUpdateSocketOpen,
            null
        );
    };

    const onUpdateSocketError = (error) => {
        console.error('Socket error:', error);
        // The 'onclose' event will fire after 'onerror', which handles reconnection.
    };

    const onUpdateSocketClose = (event) => {
        console.log(`Socket closed. Clean: ${event.wasClean}, Code: ${event.code}, Reason: ${event.reason}`);
        stopHeartbeat();
        if (event.wasClean || !isOnlineRef.current) {
            return; // Don't reconnect on clean close or if offline
        }
        scheduleReconnection();
    };

    const onUpdateSocketOpen = () => {
        console.log('Socket connection established.');
        // If a reconnection attempt was in progress, it means the connection was lost.
        // Therefore, we should fetch the latest data to ensure consistency.
        if (reconnectionAttemptsRef.current > 0) {
            console.log('Reconnected successfully. Fetching latest data...');
            fetchAnalyticsData();
        }
        if (reconnectionTimeoutRef.current) {
            clearTimeout(reconnectionTimeoutRef.current);
            reconnectionTimeoutRef.current = null;
        }
        reconnectionAttemptsRef.current = 0;
        startHeartbeat();
    };

    const scheduleReconnection = () => {
        if (reconnectionAttemptsRef.current >= 5) {
            console.error('Failed to reconnect after 5 attempts. Giving up.');
            reconnectionAttemptsRef.current = 0;
            return;
        }
        // First attempt after 30 seconds, subsequent attempts every 60 seconds
        const delay = reconnectionAttemptsRef.current === 0 ? 30000 : 60000;

        console.log(`Socket closed. Attempting to reconnect in ${delay / 1000}s...`);

        reconnectionTimeoutRef.current = setTimeout(() => {
            reconnectionAttemptsRef.current++;
            console.log(`Reconnection attempt #${reconnectionAttemptsRef.current}`);
            connectSocket();
        }, delay);
    };

    const startHeartbeat = () => {
        stopHeartbeat(); // Clear any existing interval
        heartBeatIntervalRef.current = setInterval(() => {
            fetch('/favicon.ico') // Lightweight request
                .then(response => {
                    if (!response.ok) {
                        console.warn('Heartbeat fetch failed.');
                    }
                })
                .catch(error => {
                    console.error('Heartbeat error:', error);
                    // This could indicate a lost connection, which should trigger the `onclose` event.
                });
        }, 120000); // 2 minutes
    };

    const stopHeartbeat = () => {
        if (heartBeatIntervalRef.current) {
            clearInterval(heartBeatIntervalRef.current);
            heartBeatIntervalRef.current = null;
        }
    };

    const closeSocketConnection = (isClean = false) => {
        stopHeartbeat();
        if (reconnectionTimeoutRef.current) {
            clearTimeout(reconnectionTimeoutRef.current);
            reconnectionTimeoutRef.current = null;
        }
        reconnectionAttemptsRef.current = 0;

        if (socketRef.current) {
            if (socketRef.current.readyState === WebSocket.OPEN) {
                socketRef.current.close(1000, "Component unmounting");
            }
            socketRef.current = null;
        }
    };

    // useEffect(() => {
    //     if (dockIdArr && dockIdArr.length) {
    //         // dispatch({
    //         //     type: sagaActions.GET_UNLOADING_HOURS, payload: {
    //         //         "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate), "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(), "warehouse_id": selectedWarehouse.ID,
    //         //         "isDrillDown": "0"
    //         //     }
    //         // });
    //         dispatch({
    //             type: sagaActions.GET_DETENSTION_STATUS, payload: { "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate), "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(), "warehouse_id": selectedWarehouse.ID, "isDrillDown": "0" }
    //         })

    //         dispatch({
    //             type: sagaActions.GET_APPOINTMENT_COMPLIANCE,
    //             payload: { "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate), "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(), "warehouse_id": selectedWarehouse.ID, "isDrillDown": "0" }
    //         })

    //         dispatch({
    //             type: sagaActions.GET_DASHBOARD_STATUS_TRUCK_LIST, payload: { "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate), "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(), "warehouse_id": selectedWarehouse.ID, "isDrillDown": "0" }
    //         })

    //         // dispatch({
    //         //     type: sagaActions.GET_DASHBOARD_STATUS_TRUCK_LIST, payload: { "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate), "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(), "warehouse_id": selectedWarehouse.ID, "isDrillDown": "0" }
    //         // })
    //         const d = new Date()
    //         const start = new Date(d.getFullYear(), d.getMonth(), 1)
    //         dispatch({
    //             type: sagaActions.UPDATE_FACILITY_RATINGS, payload: {
    //                 "warehouse_id": selectedWarehouse.ID,
    //                 "startDate": moment(start).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
    //                 "endDate": getCurrentDate(),
    //                 "currentPage": 1,
    //                 "itemsPerPage": 10,
    //                 "rating": null,
    //                 "type": 'G'
    //             }
    //         })
    //         fetch_GET_TASK_ITEMS_DUE_LIST()
    //     }
    // }, [dockIdArr])

    useEffect(() => {
        createUnloadingHoursSection()
    }, [unloadingHours, detentionStatus, appointmentCompliance, themeSelected])

    // useEffect(() => {
    //     if (autoFetch) {
    //         fetch_GET_DETENSTION_STATUS();
    //         fetch_GET_TASK_ITEMS_DUE_LIST();
    //         // autoFetchAPI()
    //     }
    // }, [autoFetch])

    useEffect(() => {
        dockIdArrRef.current = dockIdArr;
        if (Object.keys(dateRangeObj).length < 1 && previousDateRangeObj === undefined) {
            return
        } else if (dateRangeObj && dateRangeObj.start) {
            fetchAnalyticsData()
        }


    }, [dateRangeObj, dockIdArr])

    useEffect(() => {
        dockIdArrRef.current = dockIdArr;
        if (selectedWarehouse?.operationType === 'WORKDAY') {
            fetchAnalyticsData()
        }
    }, [isWorkDay, dockIdArr])


    // const autoFetchAPI = () => {
    //     dispatch({
    //         type: sagaActions.GET_DETENSTION_STATUS,
    //         payload: {
    //             "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
    //             "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(),
    //             "warehouse_id": selectedWarehouse.ID,
    //             "isDrillDown": "0",
    //         }
    //     })

    //     dispatch({
    //         type: sagaActions.GET_TASK_ITEMS_DUE_LIST, payload: {
    //             "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
    //             "dock_id": dockIdArr.toString() === '' ? null : dockIdArr.toString(),
    //             "warehouse_id": selectedWarehouse.ID
    //         }
    //     });
    // }
    /**
     * Fetch truck list
     */
    const fetchTruckList = () => {
        dispatch({ type: sagaActions.FETCH_TRUCK_LIST, payload: '' })
    }

    /**
     * Method is used to fetch load status overview
     */

    const fetch_DASHBOARD_STATUS_TRUCK_LIST = () => {
        const currentDockIds = dockIdArrRef.current;
        dispatch({
            type: sagaActions.GET_DASHBOARD_STATUS_TRUCK_LIST, payload: {
                "dock_id": currentDockIds.toString() === '' ? null : currentDockIds.toString(),
                "warehouse_id": selectedWarehouse.ID,
                "date": selectedWarehouse?.operationType === 'WORKDAY' && isWorkDay ? null : getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "isDrillDown": "0",
            }
        });
    }
    /**
     * Method is used to fetch Task Item Due
     */
    const fetch_GET_TASK_ITEMS_DUE_LIST = () => {
        const currentDockIds = dockIdArrRef.current;
        dispatch({
            type: sagaActions.GET_TASK_ITEMS_DUE_LIST, payload: {
                // "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "date": selectedWarehouse?.operationType === 'WORKDAY' && isWorkDay ? null : getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "dock_id": currentDockIds.toString() === '' ? null : currentDockIds.toString(),
                "warehouse_id": selectedWarehouse.ID
            }
        });
    }
    /**
    * Method is used to fetch Detention Status
    */
    const fetch_GET_DETENSTION_STATUS = () => {
        const currentDockIds = dockIdArrRef.current;
        dispatch({
            type: sagaActions.GET_DETENSTION_STATUS,
            payload: {
                // "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "date": selectedWarehouse?.operationType === 'WORKDAY' && isWorkDay ? null : getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "dock_id": currentDockIds.toString() === '' ? null : currentDockIds.toString(),
                "warehouse_id": selectedWarehouse.ID,
                "isDrillDown": "0",
            }
        })
    }
    /**
    * Method is used to fetch Appointment Compliance
    */
    const fetch_GET_APPOINTMENT_COMPLIANCE = () => {
        const currentDockIds = dockIdArrRef.current;
        dispatch({
            type: sagaActions.GET_APPOINTMENT_COMPLIANCE,
            payload: {
                // "date": getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "date": selectedWarehouse?.operationType === 'WORKDAY' && isWorkDay ? null : getFormattedDate(YYYY_MM_DD_FORMAT, selectedDate),
                "dock_id": currentDockIds.toString() === '' ? null : currentDockIds.toString(),
                "warehouse_id": selectedWarehouse.ID,
                "isDrillDown": "0",
            }
        })
    }
    /**
      * Method is used to fetch All Default analytics data at once
      */
    const fetchAnalyticsData = () => {
        fetchTruckList()
        fetch_DASHBOARD_STATUS_TRUCK_LIST()
        fetch_GET_TASK_ITEMS_DUE_LIST()
        fetch_GET_DETENSTION_STATUS()
        fetch_GET_APPOINTMENT_COMPLIANCE()



        //Implemented realtime refresh
        // dispatch({ type: sagaActions.INTIATE_AUTO_FETCH, payload: false })
    }

    const createUnloadingHoursSection = (stop) => {
        if (!_.isEmpty(unloadingHours)) {
            const { truck_details, pallet_details, arrowSign, perHrPalletsCount, perHrTruckCount } = unloadingHours;
            const donutData = createChartsProps([_.sum(truck_details), _.sum(pallet_details)], donutType.unloadingHoursdonut, themeSelected, unloadingHoursDonut)
            const lineDataTruck = createChartsProps(truck_details, donutType.unloadingHoursTruck, themeSelected, unloadingHoursLineTruck)
            const lineDataPallet = createChartsProps(pallet_details, donutType.unloadingHoursPallet, themeSelected, unloadingHoursLinePallet)
            const newUnload = { ...props, donutData, lineDataTruck, lineDataPallet, arrowSign, perHrPalletsCount, perHrTruckCount }
            setUnloadingHoursData(newUnload)
        } else {
            setUnloadingHoursData({ ...props, unloadingHoursDonut, unloadingHoursLineTruck, unloadingHoursLinePallet })
        }
        if (!_.isEmpty(detentionStatus)) {
            const datadonut = detentionStatus.map(el => _.sum(el.data))
            const detentionDonut = createChartsProps(datadonut, donutType.detentionStatusDonut, themeSelected, detentionDonutdata)
            const detentionLine = createChartsProps(detentionStatus, donutType.detentionStatusLine, themeSelected, detentionLineData)
            let newdetentionStatusData = { ...props, detentionDonut, detentionLine }
            setDetentionStatusData(newdetentionStatusData)
        } else {
            setDetentionStatusData({ ...props, detentionDonutdata, detentionLineData })
        }
        if (_.size(appointmentCompliance)) {
            // let { appointmentComplianceChart } = appointmentComplianceState;
            if (appointmentComplianceData) {
                const appointmentComplianceChart = createChartsProps(appointmentCompliance, donutType.appointmentCompliance, themeSelected, appointmentComplianceData)
                let setData = { ...props, appointmentComplianceChart };
                setData.themeSelected = themeSelected
                setAppointmentComplianceState(setData)
            } else {
                setAppointmentComplianceState({ ...props, appointmentComplianceData })
            }
        } else {
            setAppointmentComplianceState({ ...props, appointmentComplianceData })
        }
    }
    return (
        <div className={`container-fluid dashboard defaultDashboard ${themeSelected} m-0 p-0`}>
            <div className={`dashboard-row-top d-flex mb-3 mt-3 ms-0 me-0 ps-0 pe-0 ${themeSelected}`}>
                <StatusOverviewDash themeSelected={props.themeSelected} />
                <TaskItemsDue themeSelected={props.themeSelected} />
            </div>
            {/* commented as per requirement wp-892. Need to redesigned  */}
            {/* <div className={`row mt-3 unloadingHoursWrapper ${themeSelected}`}>
   <UnloadingHours {...unloadingHoursData} />
 </div> */}
            <div className={`dashboard-row-bottom d-flex flex-wrap mb-3 mt-3 ms-0 me-0 ps-0 pe-0 ${themeSelected}`}>
                <DetentionStatus {...detentionStatusData} />
                <AppointmentCompliance {...appointmentComplianceState} />
            </div>
        </div>
    )
}

export default DefaultDashboardWrapper;
